<script lang="ts">
    import Root        from './site/main/Root.svelte';
    import EnglishRoot from './english-site/main/Root.svelte';

	export let amountSupporter;
	export let amountDonatedMoney;
  export let resultDate;

    let languages = [
		{ id: 1, status: true,  lang: 'Japanese' },
		{ id: 2, status: false, lang: 'English'}
	]

	let nowLanguage = 'Japanese';

	function switchLanguage(toggled) {
		languages = languages.map(lang => {
			if(lang === toggled) {
				nowLanguage = lang.lang
				return {
					id:     lang.id,
					status: true,
					lang:   lang.lang
				}
			} else {
				return {
					id:     lang.id,
					status: false,
					lang:   lang.lang
				}
			}
		})
	}
</script>

<div id="select-language-area">
	<ul class="language-container">
		{#each languages as language}
			<li class="language-container__item">
				<button class="language-container__button" on:click={() => switchLanguage(language)}>{language.lang}</button>
			</li>
		{/each}
	</ul>
</div>

{#if nowLanguage === 'Japanese'}
    <Root amountSupporter={amountSupporter} amountDonatedMoney={amountDonatedMoney} resultDate={resultDate}/>
{:else if nowLanguage === 'English'}
    <EnglishRoot amountSupporter={amountSupporter} amountDonatedMoney={amountDonatedMoney} resultDate={resultDate}/>
{/if}

<style>

	#select-language-area {
		position: absolute;
		display:  block;
		width:    100%;
		margin:   0;
		padding:  20px 0;
		text-align: right;
		z-index:  999;
	}

	#select-language-area .language-container{
		width:   100%;
		margin:  0 auto 0 ;
		padding: 0;
	}

	#select-language-area .language-container__item {	
		display: inline-block;
	}

	#select-language-area .language-container__button {
		width:            96px;
		padding:          0;
		font-size:        18px;
		font-weight:      bold;
		color:            white;
		text-shadow:      1px 1px 8px #1e80b8;
		background-color: transparent;
		border:           none;
		border-radius:    8px;
		transition:       0.5s;
	}
    
	#select-language-area .language-container__button:hover {
		color:       #6fb0d5;
		text-shadow: 1px 1px 8px white;
	}
</style>